import { Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { StationService } from 'src/app/_services/station.service';
import { SnackbarService } from '../../../_service/message-service';
import { LoaderService } from 'src/app/loader.service';
import { Observable, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import { TableColumn } from 'src/app/shared/interfaces/table-column';
import { TableBtn } from 'src/app/shared/interfaces/table-btn';
import { NgxQrcodeElementTypes, NgxQrcodeErrorCorrectionLevels } from '@techiediaries/ngx-qrcode';
import { MatDialog } from '@angular/material/dialog';
import { StationListData } from './station-list.model';
import { GeneralDialogComponent } from 'src/app/shared/components/general-dialog/general-dialog.component';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { Permission } from 'src/app/util/enums/permission.enum';
import { MenuRouteID } from '../../header/menu-item/nav-item';
import { BreadcrumbService } from '../../breadcrumb/breadcrumb.service';
import { RouteConstants } from 'src/app/util/route.constants';

@Component({
  selector: 'telio-stations-list',
  templateUrl: './stations-list.component.html',
  styleUrls: ['./stations-list.component.scss']
})
export class StationsListComponent implements OnInit, OnDestroy {
  userid: any;
  vendormailid: any;
  currentuser: any = {};
  subscription: Subscription = new Subscription;
  boxId;
  operatorId: any;
  boxStatus = '';
  stnid: any = {};
  vendor: any = {}
  @Input() vendorId: any;
  columns: TableColumn[];
  buttons: TableBtn[];
  data: StationListData[];
  actionHeader: string = '';
  filterPlaceholder: string = '';
  pageList = {
    currentPage: 0,
    pageSize: 10
  };
  currentPage = 0;
  totalDataCount = 0;
  sortColumn = '';
  sortDirection = 'asc';
  statesave = false;
  elementType = NgxQrcodeElementTypes.URL;
  correctionLevel = NgxQrcodeErrorCorrectionLevels.HIGH;
  value;
  chargeBoxId;
  totalConnectors;
  urlSegments = this.route.snapshot.url[0].path;
  @Input() routeID = null;

  @ViewChild('callOtpDialog', { static: false }) callOtpDialog: TemplateRef<any>;
  @Input() actionFeatureFlag = false;
  actionFeatureLabel: string = 'Add Charging Station';
  @Input() cpoDetailPage = false;


  constructor(
    private router: Router,
    private stationService: StationService,
    private userInfoService: UserInfoService,
    private toastr: SnackbarService,
    public loaderService: LoaderService,
    public translate: TranslateService,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    readonly breadcrumbService: BreadcrumbService
  ) {
    this.currentuser = this.userInfoService.userDetails;
    this.userid = this.userInfoService.userDetails.userId;
    this.vendormailid = this.userInfoService.userDetails.email;

    this.columns = [
      { columnDef: 'vendorName', header: 'cpoList.cpoName', cell: (element: StationListData) => `${element.vendorName}`, sortingDisabled: true, width: 'auto', isLink: this.urlSegments == 'stations' ? this.userInfoService.isTabExists(+this.route.snapshot.paramMap.get('routeID')) : false },
      { columnDef: 'name', header: 'stationList.name', cell: (element: StationListData) => `${element.name}`, sortingDisabled: false, width: 'auto', isLink: this.userInfoService.isTabExists(+this.route.snapshot.paramMap.get('routeID')) },
      { columnDef: 'chargeboxId', header: 'wallets.chargeboxId', cell: (element: StationListData) => `${element.chargeboxId}`, sortingDisabled: false, width: 'auto' },
      { columnDef: 'type', header: 'stationList.type', cell: (element: StationListData) => `${element.type}`, sortingDisabled: false, width: '70px' },
      { columnDef: 'aconnectors', header: 'stationList.connectors', cell: (element: StationListData) => `${element.aconnectors}`, sortingDisabled: true, width: '73px' },
      { columnDef: 'portTypes', header: 'stationList.portType', cell: (element: StationListData) => `${element.portTypes}`, sortingDisabled: true, width: '190px', isConnectorImg :true },
      { columnDef: 'address', header: 'stationList.location', cell: (element: StationListData) => `${element.address}`, sortingDisabled: false, width: 'auto' },
      { columnDef: 'energyConsumption', header: 'stationList.energyConsumption', cell: (element: StationListData) => `${element.energyConsumption}`, sortingDisabled: true, width: '126px' },
      { columnDef: 'activeStatus', header: 'stationList.status', cell: (element: StationListData) => `${element.activeStatus}`, sortingDisabled: true, width: '75px', caseSensitive: 'uppercase' },
      { columnDef: 'stationManager', header: 'cmsUsers.stationManager', cell: (element: StationListData) => `${element.stationManager}`, sortingDisabled: true, width: '110px' }
    ];

    this.actionHeader = 'actions';
    this.filterPlaceholder = 'generalTable.filterPlaceholder';
  }

  ngOnInit() {
    this.actionFeatureLabel = 'dashboard.addStationButton';
    this.actionFeatureFlag = (!!this.routeID) ? false : this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.CREATE);

    this.buttons = [
      { styleClass: 'submit', icon: 'qr_code_scanner', payload: (element: StationListData) => `${element.chargeboxId}`, action: 'qr', tooltip: 'QR', enable: this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.READ) },
      { styleClass: 'submit', icon: 'edit', payload: (element: StationListData) => `${element.chargeboxId}`, action: 'edit', tooltip: 'stationDetail.edit', enable: this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.UPDATE) },
      { styleClass: 'submit', icon: '360', payload: (element: StationListData) => `${element.chargeboxId}`, action: 'statusChange', tooltip: 'stationList.changeStatus', enable: this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.UPDATE) },
      { styleClass: 'submit', icon: 'delete', payload: (element: StationListData) => `${element.chargeboxId}`, action: 'delete', tooltip: 'stationDetail.delete', enable: this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.DELETE) }
    ];
    
    this.rerender(this.pageList, '');
  }

  // getstationlist to get list of stations
  getstationlist(value: any, searchFilter: string = '') {
    let URL: Observable<any>;

    if (!this.cpoDetailPage) {
      URL = this.stationService.getListofStationsSuperAdmin(value.currentPage + 1, value.pageSize, this.sortColumn, this.sortDirection, searchFilter);
    } else {
      let vendormailid = !!this.vendorId ? this.vendorId : this.vendormailid;
      URL = this.stationService.getListofStationsCpo(vendormailid, value.currentPage + 1, value.pageSize, this.sortColumn, this.sortDirection, searchFilter);
    }

    this.subscription.add(URL
      .pipe(map(events => {
        this.setStationsMap(events.data);
        this.totalDataCount = events.totalItems;
      })).subscribe());
  }

  // setStationsMap(events) {
  //   if (!!events && events.length > 0) {
  //     let empty='NA';
  //     this.data = events;
  //     this.data.map((event: any, i: number) => {
  //       event.id = i;
  //       event.vendorId = event.vendorId,
  //         event.vendorName = event.vendorName,
  //         event.name = event.name,
  //         event.type = event.type,
  //         event.connectorsFull = event.connectors
  //         event.connectors = event.connectors.map(res => {
  //         return {
  //           availableConnectors: res.availableConnectors,
  //           totalConnectors: res.totalConnectors,
  //           portTypes: res.connectors.map(resp => `${resp.portType} : ${resp.chargingStatus || empty}`).join(',')
  //         }
  //       }),
  //         event.chargeboxId = event.chargeboxId,
  //         event.address = event.address,
  //         event.activeStatus = (event.status.toLowerCase() == "available" || event.status.toLowerCase() == "active") ? "ACTIVE" : "INACTIVE",
  //         event.status = event.status,
  //         event.vrating = event.vrating,
  //         event.priceperunit = event.priceperunit,
  //         event.userStatus = (event.status.toLowerCase() == "available" || event.status.toLowerCase() == "active"),
  //         event.country = event.country,
  //         event.city = event.city,
  //         event.location = (event.country && event.city) ? event.country + ', ' + event.city : event.country || event.city || 'NA',
  //         event.aconnectors = event.connectors[0].totalConnectors,
  //         // event.portTypes = event.connectors[0].portTypes
  //         event.portTypes = event.connectors.map(connector => connector.portTypes).join(',');
  //         event.stationManager = event.stationManager ? event.stationManager : "NA"
  //     })
  //   }
  //   else {
  //     this.data = [];
  //   }
  // }

  setStationsMap(events) {
    if (!!events && events.length > 0) {
      const empty = 'NA';
      this.data = events.map((event, i) => {
        const connectors = event.connectors.map(connector => {
          return connector.connectors.map(res => {
            let portType = res.portType;
            if (portType === 'GB/T') {
              portType = 'GBT';
            } else if (portType === 'Type-6') {
              portType = 'Type 6'; 
            }
  
            return {
              imgURL: `/assets/images/connector/${encodeURIComponent(portType)}-${(res.chargingStatus || 'other').toLowerCase()}.png`
            };
          });
        }).flat();
        const imgURLs = connectors.map(connector => connector.imgURL);
  
        return {
          id: i,
          vendorId: event.vendorId,
          vendorName: event.vendorName,
          name: event.name,
          type: event.type,
          connectorsFull: event.connectors,
          energyConsumption:event.energyConsumption,
          connectors: connectors,
          chargeboxId: event.chargeboxId,
          address: event.address,
          activeStatus: (event.status.toLowerCase() == "available" || event.status.toLowerCase() == "active") ? "ACTIVE" : "INACTIVE",
          status: event.status,
          vrating: event.vrating,
          priceperunit: event.priceperunit,
          userStatus: (event.status.toLowerCase() == "available" || event.status.toLowerCase() == "active"),
          country: event.country,
          city: event.city,
          location: (event.country && event.city) ? `${event.country}, ${event.city}` : event.country || event.city || 'NA',
          aconnectors: event.connectors[0].totalConnectors,
          portTypes: imgURLs,
          stationManager: event.stationManager || "NA"
        };
      });
    } else {
      this.data = [];
    }
  }

  deletestationtbyid(deleteid: any) {
    this.subscription.add(this.stationService.deletestationtbyid(deleteid).subscribe(
      (resp: any) => {
        if (!!resp) {
          this.toastr.success(resp);
          this.rerender(this.pageList);
        }
      },
      error => {
        this.toastr.error(error);
      }
    ));
  }

  updateStation(ele) {
    this.operatorId = ele.chargeboxId;
    this.boxId = ele.vendorId;
    if ((ele.status.toLowerCase() == "available")) {
      this.boxStatus = "Unavailable"
    }
    if ((ele.status.toLowerCase() == "unavailable")) {
      this.boxStatus = "Available"
    }

    this.updateFeature(ele.activeStatus);
  }

  stndetails(stndata) {
    this.stnid = stndata.chargeboxId;
    this.router.navigate(['/dashboard/stations/details', { routeID: MenuRouteID.STATIONS }], { queryParams: { "stationid": JSON.stringify(this.stnid), "routedName": this.vendorId ? 'vendorStations' : 'staionlist', } })
    this.breadcrumbService.emitBreadCrumbs(RouteConstants.LIST_OF_STATION_DETAILS);
  }

  operatorDetails(data) {
    this.vendor = data.vendorId;
    this.router.navigate(['/dashboard/operators/details', { routeID: MenuRouteID.OPERATORS }], { queryParams: { "vendorid": JSON.stringify(this.vendor), index: '0', routedName: 'stationlist' } });
    this.breadcrumbService.emitBreadCrumbs(RouteConstants.OPERATOR_INFO);
  }

  editStationIs(station, stationId) {
    let objToSend: NavigationExtras = {
      queryParams: {
        "routedName": this.vendorId ? 'vendorStations' : 'staionlist',
        "stationId": stationId,
        "vendorId": station[0].vendorId
      },
      skipLocationChange: true
    };

    this.router.navigate(["/dashboard/add-station", { routeID: MenuRouteID.STATIONS }], objToSend);
  }

  updateStationbyId() {
    this.subscription.add(this.stationService.chargeboxUpdate(this.boxId, this.operatorId, this.boxStatus).subscribe((resp: any) => {
      if (!!resp) {
        if (resp.body) {
          let msg = this.boxStatus === "Available" ? this.translate.instant('stationList.activatedSuccess') : this.translate.instant('stationList.deActivatedSuccess');
          this.toastr.success(msg);
        }
        else if (resp.statusCode === 400){
          this.toastr.error(resp.message)
        }
        this.rerender(this.pageList);
      }
      else if (resp.statusCode === 400) {
        this.toastr.error(resp.message)
      }
      else {
        this.toastr.error(this.translate.instant('rfid.updateFail'))
      }
    }));
  }


  //Mani
  applyFilter(filteredData: string) {
    this.rerender(this.pageList, filteredData)
  }

  buttonClick(result: string[]) {
    if (result[0] == 'delete') {
      this.deleteFeature(result[1]);
    } else if ((result[0] == 'edit')) {
      let item = this.data.filter(res => res.chargeboxId == result[1])
      this.editStationIs(item, result[1]);
    } else if (result[0] == 'view') {
      let item = this.data.find(res => res.chargeboxId == result[1])
      this.stndetails(item);
    } else if (result[0] == 'qr') {
      let item = this.data.find(res => res.chargeboxId == result[1])
      this.viewQR(item);
    } else {
      let item = this.data.find(res => res.chargeboxId == result[1])
      this.updateStation(item);
    }

  }

  actionClick(event) {
    this.rerender(this.pageList);
  }

  actionCSV(event) {
  }

  rerender(value: any, searchFilter?: string) {
    this.getstationlist(value, searchFilter);
  }

  loadData(value: any) {
    let val = {
      currentPage: value.currentPage,
      pageSize: value.pageSize
    }
    this.pageList.pageSize = value.pageSize;
    this.rerender(val, '')
  }

  viewQR(item) {
    this.chargeBoxId = item.chargeboxId;
    this.totalConnectors = item.connectorsFull[0].connectors
    this.totalConnectors.forEach(ele => {
      ele['name'] = this.chargeBoxId + "_" + ele.connectorId
      ele['value'] = JSON.stringify({ "chargeboxId": this.chargeBoxId, "connectorId": ele.connectorId })
    });
    this.openOtpDailog()
  }

  openOtpDailog() {
    let dialogRef = this.dialog.open(this.callOtpDialog, {
      height: '500px',
      width: '400px'
    }).afterClosed().subscribe((res: any) => {
    })
  }

  downloadQR(item) {
    const fileNameToDownload = item.name;
    let index;
    index = this.totalConnectors.findIndex(res => res.connectorId == item.connectorId)
    const base64Img = document.getElementsByClassName('coolQRCode')[index].children[0]['src'];
    fetch(base64Img)
      .then(res => res.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileNameToDownload;
        link.click();
      })
  }

  ngOnDestroy() {
    this.subscription && this.subscription.unsubscribe();
  }

  sortClick(event: any) {
    this.sortColumn = event.active;
    this.sortDirection = event.direction;
    this.rerender(this.pageList, '');
  }

  linkClick(event) {
    if (event.column.columnDef == "name") {
      this.stndetails(event.row);
    }
    else if (event.column.columnDef == "vendorName") {
      this.operatorDetails(event.row);
    }
  }

  deleteFeature(id): void {
    let dialogRef = this.dialog.open(GeneralDialogComponent, {
      width: '50vw',
      height: '200px',
      data: { component: ConfirmDialogComponent, button: this.translate.instant('faq.confirmButton'), title: this.translate.instant('createStation.confiration'), otherbtn: this.translate.instant('faq.confirmNo'), message: this.translate.instant('stationList.deletePopupTitle') }
    }).afterClosed().subscribe(res => {
      if (res && res == 'Yes') {
        this.deletestationtbyid(id);
      }
    });
  }

  updateFeature(status: string): void {
    let dialogRef = this.dialog.open(GeneralDialogComponent, {
      width: '50vw',
      height: '200px',
      data: { component: ConfirmDialogComponent, button: this.translate.instant('faq.confirmButton'), title: this.translate.instant('createStation.confiration'), otherbtn: this.translate.instant('faq.confirmNo'), message: status.toLowerCase() == 'inactive' ? this.translate.instant('stationList.statusActivate') : this.translate.instant('stationList.statusDeactivate') }
    }).afterClosed().subscribe(res => {
      if (res && res == 'Yes') {
        this.updateStationbyId();
      }
    });
  }

  checkPermission(id: number, permission: string): boolean {
    let routeID = !!this.routeID ? this.routeID : id;
    return this.userInfoService.filterPermission(routeID, permission)
  }

  actionFeature(event) {
    this.router.navigate(['/dashboard/add-station', { routeID: this.route.snapshot.paramMap.get('routeID') }]);
    this.breadcrumbService.emitBreadCrumbs(RouteConstants.ADD_STATION);
  }

}
